import React, { useState } from "react";
import { sendSignupEmail } from "../lib/email";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Hero() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [hp, setHp] = useState(""); // honeypot

  async function handleSubmit(e) {
    e.preventDefault();
    if (hp) return; // bot check

    if (!name.trim()) {
      setStatus({ type: "error", msg: "Please enter your name." });
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      setStatus({ type: "error", msg: "Please enter a valid email." });
      return;
    }

    try {
      await sendSignupEmail({ name: name.trim(), email, source: "hero" });
      setStatus({ type: "success", msg: "Thanks! You’re on the list." });
      setName("");
      setEmail("");
    } catch (err) {
      console.error(err);
      setStatus({ type: "error", msg: "Something went wrong. Try again." });
    }
  }

  return (
    <header className="lk-section lk-hero">
      <div className="lk-container">
        <div className="lk-hero-copy">
          <span className="lk-badge">LeadKey AI</span>
          <h1>
            Never miss a lead. <span className="lk-highlight">Ever.</span>
          </h1>
          <p className="lk-sub">
            Friendly AI receptionists and agents that answer calls & messages
            24/7, book appointments, qualify leads, and follow up—so you save
            time, cut costs, and win more business.
          </p>

          <form className="lk-form" onSubmit={handleSubmit}>
            {/* Honeypot (hidden) */}
            <input
              type="text"
              name="company"
              value={hp}
              onChange={(e) => setHp(e.target.value)}
              tabIndex="-1"
              autoComplete="off"
              style={{ position: "absolute", left: "-9999px", height: 0, width: 0 }}
              aria-hidden="true"
            />

            <input
              type="text"
              name="name"
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              aria-label="Your name"
              required
            />
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Email address"
              required
            />
            <button type="submit">Get Early Access</button>
          </form>

          {status.msg && (
            <p
              className={
                status.type === "success" ? "lk-msg success" : "lk-msg error"
              }
              role="status"
            >
              {status.msg}
            </p>
          )}

          <p className="lk-micro">Join the waitlist—be first to try it.</p>
        </div>

        <div className="lk-hero-card" aria-hidden>
          <div className="lk-phone">
            <div className="lk-bubble left">“Can you show 123 Main St at 5pm?”</div>
            <div className="lk-bubble right">“Booked! Calendar invite sent.”</div>
            <div className="lk-bubble left">“Do you accept VA loans?”</div>
            <div className="lk-bubble right">“Yes—here’s a quick guide.”</div>
          </div>
        </div>
      </div>
    </header>
  );
}
